export const rabbitSignFolderStatuses = Object.freeze({
  created: "CREATED",
  signed: "SIGNED",
  canceled: "CANCELED"
});